export function toPostgrestIlikeValue(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  const likeLiteral = trimmed
    .replace(/\\/g, '\\\\')
    .replace(/%/g, '\\%')
    .replace(/_/g, '\\_');

  const inner = likeLiteral.replace(/"/g, '\\"');
  return `"%${inner}%"`;
}
